<template lang="html">
  <div class="container">
    <div class="list_div">
        <Table :columns="project_columns" :data="project_list"></Table>
        <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div>
    </div>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail } from '../../../service'
import filter from 'js/filter'
export default {
  inject: ['reload'],
  data() {
    return {
      spinShow: true,
      params: {
        uid: this.$route.params.uid,
        type: 'dwtz',
        entity_type: 1
      },
      project: [],
      project_list: [],
      total: 0,
      project_columns: [
        { title: '项目名',width: 180, render: (h, params) => {
          return h('div',{
              class: {company: true}
            },[
            h('div',
              {
                class: {logo_img: true},
                on: {click: () => {this.goEntityDetail(params.row.comp_uid, params.row.ht_comp_type)}},
              },[
                h('img', { attrs: {src: filter.logo_show(params.row.ht_logo_path)}})
              ]),
            h('div',
              {class: {company_name: true}},[
                h('p', [
                  h('a',{
                    on: {click: () => {this.goEntityDetail(params.row.comp_uid, params.row.ht_comp_type)}}
                  }, params.row.ht_comp_name)
                ]),
              ])
          ])
        }},
        {title: '业务概况',minWidth: 120,render: (h, params) => {
            return h('div',{class: {'dec-clamp': true}},filter.empty(params.row.ht_description))
          }
        },
        { title: '地区', key: 'area',width: 120, render: (h, params) => {return h('span', filter.pc(params.row.ht_province, params.row.ht_city))}},
        { title: '行业', key: 'tags',width: 160, render: (h, params) => {
          // return h('span', filter.empty(params.row.comp_nxfly))
          if (params.row.tags != '') {
            return h('span', filter.dealString(params.row.tags, 'dynview_tag'))
          } else {
            return h('span', '--')
          }
        }},
        { title: '当前轮次',width: 100, key: 'round_id', render: (h, params) => {return h('span', filter.deal(params.row.ht_round, 'round'))}},
        { title: '最近融资时间',width: 120, key: 'latest_event_time',minWidth: 100, render: (h, params) => {return h('span', filter.timeTrans(params.row.event_time))}},
        { title: '过往参与轮次',width: 100, key: 'before_round', render: (h, params) => {
          if (params.row.before_round.length != 0) {
            let s = params.row.before_round.join(',')
            return h('span', filter.dealString(s, 'round'))
          } else {
            return h('span', '--')
          }
        }}
      ]
    }
  },
  computed: {
    uid() {
      return this.$route.params.uid
    }
  },
  methods: {
    async getDetail() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'project', res.dwtz)
        if(res.dwtz.length > 0) this.$emit('callbackData', 'ProjectInfo')
        this.$set(this.$data, 'project_list', [...res.dwtz].slice(0,10))
        this.total = res.dwtz.length
        this.$emit('getcount', {
          comp_count: res.comp_count,
          event_count: res.event_count,
          to_next_round_count: res.to_next_round_count
        })
      } else {
        this.$Message.error(res.msg)
      }
      this.$nextTick(() => {this.spinShow = false})
    },
    handlePage(page) {
      this.$set(this.$data, 'project_list', [...this.project].slice(10*(page-1),10*page))
    },
    goEntityDetail(uid, type) {
      if (type == 2) {
        // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 1){
        // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 0){
        // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if(type == 3){
        // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    }
  },
  created() {
    this.getDetail()
  },
  watch: {
    uid(val) {
      this.spinShow = true
      this.getDetail()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.container
  min-height: 400px
.list_div
  padding: 40px 32px
  >>> .dec-clamp
    max-height: 40px
    line-height: 20px
    ellipsisClamp2()
</style>
